import { GenericDateFilterFactory } from "../_generics";
import { GENERIC_IDS } from "../_constants/generics.constants";

export const UserLogsDateFilterStore = GenericDateFilterFactory(GENERIC_IDS.USER_LOGS);